import React, { useState } from 'react';
import { MapPin } from 'lucide-react';
import { toast } from 'sonner';
import ScrollableCardModal from './ScrollableCardModal';

const RunCard = ({ 
  runner, 
  onClick, 
  showHover = true,
  showLocation = true,
  buttonText = "View Card",
  onButtonClick,
  // Image positioning props
  isPositioning = false,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onMouseLeave
}) => {
  const [showRunnerModal, setShowRunnerModal] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick(runner);
    }
  };

  const handleButtonClick = (e) => {
    e.stopPropagation();
    if (onButtonClick) {
      onButtonClick(runner);
    } else {
      // Open runner modal
      setShowRunnerModal(true);
    }
  };

  return (
    <div
      className={`rounded-3xl overflow-hidden shadow-2xl border-2 border-black relative w-[400px] ${
        showHover ? 'hover:scale-105 transition-transform duration-300' : ''
      } ${onClick ? 'cursor-pointer' : ''}`}
      style={{ border: '1px solid rgba(255, 255, 255, 0.2)' }}
      onClick={handleClick}
    >
      <div 
        className="relative h-[500px]"
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}
        style={{ 
          cursor: isPositioning ? 'crosshair' : 'default' 
        }}
      >
        {runner.runcard_image ? (
          <img 
            src={runner.runcard_image} 
            alt={runner.name}
            className="w-full h-full object-cover brightness-90"
            style={{
              objectPosition: 'center center'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
              const nextElement = e.target.nextElementSibling;
              if (nextElement) {
                nextElement.style.display = 'flex';
              }
            }}
          />
        ) : null}
        <div className="w-full h-full spray-paint-placeholder" style={{display: runner.runcard_image ? 'none' : 'flex'}}>
        </div>
        
        {/* Runner Type Badge - Top Left */}
        <div className="absolute top-4 left-4">
          <span 
            className="bg-black/60 backdrop-blur-sm text-white px-2 py-1 rounded-full text-xs font-medium border border-white/20"
            style={{
              cursor: 'default',
              pointerEvents: 'none',
              userSelect: 'none'
            }}
          >
            Runner
          </span>
        </div>
        
        {/* Text content - Bottom left positioning */}
        <div className="absolute bottom-8 left-8">
          {/* Runner Name */}
          <h3 className="text-3xl font-bold text-white mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
            {runner.name}
          </h3>
          
          {/* City */}
          {showLocation && runner.location && (
            <div className="flex items-center text-white/90">
              <MapPin className="w-5 h-5 mr-3 flex-shrink-0" />
              <span className="text-base font-medium" style={{fontFamily: 'Montserrat, sans-serif'}}>
                {runner.location}
              </span>
            </div>
          )}
        </div>
        
        {/* Action button - Bottom right positioning */}
        {onButtonClick && (
          <div className="absolute bottom-8 right-8">
            <button 
              className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium border border-white/30 hover:bg-white/30 transition-colors"
              style={{fontFamily: 'Montserrat, sans-serif'}}
              onClick={handleButtonClick}
            >
              {buttonText}
            </button>
          </div>
        )}
      </div>

      {/* Runner Modal */}
      <ScrollableCardModal
        cardType="runner"
        cardId={runner.id}
        isOpen={showRunnerModal}
        onClose={() => setShowRunnerModal(false)}
      />
    </div>
  );
};

export default RunCard;

